import sycamoreServiceClient from '.';

export const fetchInvestment = async offer_link => {
  const response = await sycamoreServiceClient({
    url: `/investment/contract/${offer_link}`,
    method: 'get',
  });

  return {
    status: response.status,
    data: response.data,
  };
};

export const fetchCommercial = async offer_link => {
  const response = await sycamoreServiceClient({
    url: `/customer/commercial/paper/contract/${offer_link}`,
    method: 'get',
  },
  '___target'
);

  return {
    status: response.status,
    data: response.data,
  };
};

export const decideContract = async body => {
  const response = await sycamoreServiceClient({
    url: '/investment/contract/decide',
    method: 'post',
    data: body,
  });

  return {
    status: response.status,
    data: response.data,
  };
};

export const decideCommercialContract = async body => {
  const response = await sycamoreServiceClient({
    url: '/customer/commercial/paper/contract/decide',
    method: 'post',
    data: body,
  }
  , '___target');

  return {
    status: response.status,
    data: response.data,
  };
};
